<template>
  <component :is="productCardType" v-bind="props" />
</template>

<script setup>
  import ProductCardTypeA from './product-card-type-a.vue';
  import ProductCardTypeB from './product-card-type-b.vue';
  import ProductCardTypeC from './product-card-type-c.vue';
  import ProductCardTypeD from './product-card-type-d.vue';
  import ProductCardTypeE from './product-card-type-e.vue';
  import productCardProps from './product-card-props';

  const props = defineProps({
    type: {
      type: String,
      required: true,
    },
    ...productCardProps,
  });

  /**
   * ProductCardTypeA is used in PLP, Homepage swiper/slider, Recently Viewed
   * ProductCardTypeB is used in collaboration pages like Hest, Guitar, Wilderdog
   * ProductCardTypeC is used in PDP page on Complete the look section
   * ProductCardTypeD is used in Wishlist pages like Wislist listing page, Share page
   * ProductCardTypeE is used in Build Your Kit page
   */
  const cardTypeMapping = {
    TypeA: ProductCardTypeA,
    TypeB: ProductCardTypeB,
    TypeC: ProductCardTypeC,
    TypeD: ProductCardTypeD,
    TypeE: ProductCardTypeE,
  };

  const productCardType = cardTypeMapping[props.type];
</script>
